var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14 17.5c-3.698 0-6.987 1.786-9.081 4.557-.45.596-.676.895-.669 1.298a1.3 1.3 0 0 0 .446.896c.318.249.757.249 1.636.249h15.336c.88 0 1.319 0 1.636-.249a1.3 1.3 0 0 0 .446-.896c.008-.403-.218-.702-.669-1.298-2.093-2.771-5.382-4.557-9.08-4.557M14 14a5.25 5.25 0 1 0 0-10.5A5.25 5.25 0 0 0 14 14"
  })));
};
export default SvgUser;